import * as React from "react";
import CouncilBadge from "src/components/general/CouncilBadge";
import House from "src/assets/house.png";
import { ICouncil } from "src/interfaces";
import axios from "axios";
import * as qs from "query-string-for-all";
import { baseUrl } from "src/constants/ApiSettings";
import Loading from "src/components/general/Loading";
import { FormatNumber } from "src/components/utils/FormatNumber";

interface IProps {
  ordinal: number;
  council: ICouncil;
  year: string;
}

interface ITrace {
  averageIncome: number;
}

interface IState {
  data: null | ITrace;
}

export default class SingleCouncil extends React.PureComponent<IProps, IState> {
  public state: IState = { data: null };

  public componentDidMount() {
    this.generateData(this.props.council, this.props.year);
  }

  public componentWillReceiveProps(newProps: IProps) {
    if (newProps.year !== this.props.year) {
      this.generateData(newProps.council, newProps.year);
    }
  }

  public generateData = (council: ICouncil, year: string) => {
    axios
      .get(`${baseUrl}/averageWeeklyHouseholdIncome?${qs.stringify({ council: council.id, year })}`)
      .then(res => {
        const averageIncome = res.data[0].value;
        const data = { averageIncome: Math.round(averageIncome) };
        this.setState({ data });
      })
      .catch(err => {
        // tslint:disable-next-line:no-console
        console.error(err);
      });
  };

  public render() {
    const data = this.state.data;

    if (!data) {
      return (
        <div className="w-1/4 flex justify-center items-center">
          <Loading />
        </div>
      );
    }

    return (
        <div className="w-full sm:pr-4 mb-4">
          {/* Council Badge */}
          <div className="flex flex-row flex-wrap items-center justify-center">
            <CouncilBadge
              ordinal={this.props.ordinal}
              name={this.props.council.name}
              size={40}
              x={0}
              y={0}
            />
            <span style={{ maxWidth: 'calc(100% - 45px)' }}>{ this.props.council.name }</span>
          </div>
          {/* Home img */}
          <div className="my-4 mx-auto house">
            <img src={House} />
            <h2 className="text-cct-blue house__text">${ FormatNumber( data.averageIncome, 0, true ) }</h2>
          </div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/report/councilArea/PeopleEarnIn/SingleCouncil.tsx